module.exports = __webpack_public_path__ + "img/underwear_jockstrap.684176d1.png";